export const getDefaultIfUndefined = <T>(value: T, defaultValue: T): T =>
  value === undefined || (typeof value === 'string' && value === 'undefined') ? defaultValue : value;
